import axios from 'axios';
import { LogService } from '../../../../services/log-service';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { FormattedMessage } from 'react-intl';

const reconnectCarrier = (sellerLabelProvider) => {
  const reconnectEndpoint = '/provider/reconnect';
  const data = {
    providerId: sellerLabelProvider.labelProviderId,
    registerData: {
      action: 'reconnect',
      sellerProviderId: sellerLabelProvider.sellerLabelProviderId,
      providerId: sellerLabelProvider.labelProviderId,
    },
  };

  return axios
    .post(reconnectEndpoint, data)
    .then((response) => {
      if (response.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
      }
    })
    .catch((error) => {
      LogService.logError(error);
      NotificationService.showNotification({
        content: (
          <FormattedMessage
            defaultMessage='An unexpected error occurred trying to reconnect account. Please try again.'
            description='error message when unable to reconnect carrier account'
            id='o001Gk'
          />
        ),
        notificationType: NOTIFICATION_TYPE_ERROR,
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    });
};

export default reconnectCarrier;
